import axios from '../../../services/axios.service';
import { getEndpointBase } from '../../../services/api.service';
import { CreateHRDto, UpdateHRDto, HR, HRListResponse } from './HRControl.type';
import { AxiosResponse } from 'axios';

let listRequest: any = null;

const REQUEST_PREFIX = 'hr';

export const hrControlService = {
  getList: (params: {
    q?: string;
    page?: number | string;
    sort?: string;
  }): Promise<AxiosResponse<HRListResponse>> => {
    listRequest && listRequest.cancel();
    listRequest = axios.CancelToken.source();

    return axios.get(getEndpointBase(`employees`), {
      cancelToken: listRequest.token,
      params: { keywords: params.q, page: params.page, sort: params.sort, filter: { hr: true } },
    });
  },

  create: (data: CreateHRDto): Promise<AxiosResponse<HR>> => {
    return axios.post(getEndpointBase(`${REQUEST_PREFIX}/create`), data);
  },

  update: ({ id, regions }: UpdateHRDto): Promise<AxiosResponse<HR>> => {
    return axios.post(getEndpointBase(`employees/${id}/region`), { regions });
  },

  delete: (id: number): Promise<AxiosResponse> => {
    return axios.delete(getEndpointBase(`${REQUEST_PREFIX}/${id}`));
  },
};
